import Vue from "vue";
import { GridPlugin, Sort, Edit, Toolbar, CommandColumn } from "@syncfusion/ej2-vue-grids";
import TitleMixin from "@/mixins/title";
import SpinnerMixin from "@/mixins/spinner";
import RoomEditTemplate from "@/components/Templates/CalendarType/RoomEditTemplate.vue";
import EmployeeEditTemplate from "@/components/Templates/CalendarType/EmployeeEditTemplate.vue";
import { mapGetters } from "vuex";
Vue.use(GridPlugin);
export default Vue.extend({
    mixins: [TitleMixin, SpinnerMixin],
    data() {
        return {
            title: this.$t("calendarTypes.create.title"),
            employeesGrid: {
                editSettings: {
                    allowEditing: true,
                    allowAdding: true,
                    allowDeleting: true,
                    mode: "Dialog",
                    template: function () {
                        return {
                            template: Vue.component("calendar-type-employee-item", EmployeeEditTemplate)
                        };
                    }
                },
                commands: [
                    /*
                    {
                      type: "Edit",
                      buttonOption: { cssClass: "e-flat", iconCss: "e-edit e-icons" }
                    },
                    */
                    {
                        type: "Delete",
                        buttonOption: { cssClass: "e-flat", iconCss: "e-delete e-icons" }
                    }
                ],
                sortOptions: {
                    columns: [{ field: "employeeFullName", direction: "Ascending" }]
                },
                toolbar: ["Add"],
                validationOptions: {
                    rules: {
                        employeeId: {
                            required: true
                        },
                        visibility: {
                            required: true
                        }
                    }
                }
            },
            roomsGrid: {
                editSettings: {
                    allowEditing: true,
                    allowAdding: true,
                    allowDeleting: true,
                    mode: "Dialog",
                    template: function () {
                        // Get office drop down list
                        const element = document.getElementById('officeId');
                        const dropDownList = element.ej2_instances[0];
                        return {
                            template: {
                                extends: RoomEditTemplate,
                                propsData: { officeId: dropDownList.value }
                            }
                            /*
                            template: Vue.component(
                              "calendar-type-room-item",
                              RoomEditTemplate
                            )
                             */
                        };
                    }
                },
                commands: [
                    /*
                    {
                      type: "Edit",
                      buttonOption: { cssClass: "e-flat", iconCss: "e-edit e-icons" }
                    },
                    */
                    {
                        type: "Delete",
                        buttonOption: { cssClass: "e-flat", iconCss: "e-delete e-icons" }
                    }
                ],
                sortOptions: {
                    columns: [{ field: "roomName", direction: "Ascending" }]
                },
                toolbar: ["Add"],
                validationOptions: {
                    rules: {
                        roomId: {
                            required: true
                        },
                        officeId: {
                            required: true
                        }
                    }
                }
            },
            offices: [],
            calendarType: {
                name: "",
                description: "",
                employees: [],
                rooms: []
            },
            validationOptions: {
                rules: {
                    officeId: {
                        required: true
                    },
                    name: {
                        required: true,
                        rangeLength: [3, 50]
                    },
                    description: {
                        maxLength: 500
                    }
                }
            }
        };
    },
    provide: {
        grid: [Sort, Edit, Toolbar, CommandColumn]
    },
    computed: {
        ...mapGetters({
            hasMultipleOffices: "account/hasMultipleOffices",
            getSingleOfficeId: "account/getSingleOfficeId"
        })
    },
    methods: {
        create() {
            return this.$store.dispatch("calendarType/create", {
                calendarType: this.calendarType
            });
        },
        createSuccess() {
            this.$toast.showSuccessToast(this.$t("calendarTypes.create.toastSuccessTitle"), this.$t("calendarTypes.create.toastSuccessContent", {
                name: this.calendarType.name
            }));
            return this.$router.push("/administration/calendar-types");
        },
        cancel() {
            return this.$router.push("/administration/calendar-types");
        },
        employeesGridActionBegin(args) {
            if (args.requestType === "save") {
                args.data["employeeFullName"] = args.form.querySelector("#employeeId").value;
                args.data["visibilityName"] = args.form.querySelector("#visibility").value;
            }
        },
        employeesGridActionComplete(args) {
            if (args.requestType === "beginEdit" || args.requestType === "add") {
                // Add Validation Rules
                const calendarTypeEmployees = this.calendarType.employees;
                args.form.ej2_instances[0].addRules("employeeId", {
                    exists: [
                        function (args) {
                            const employeeIdOld = args.element.form.querySelector("#employeeIdOld").value;
                            if (args.value == employeeIdOld)
                                return true;
                            return !calendarTypeEmployees.some(employee => employee.employeeId == args.value);
                        },
                        this.$t("calendarTypes.employeeExists")
                    ]
                });
                args.dialog.width = 380;
                if (args.requestType === "add") {
                    args.dialog.header = this.$t("calendarTypes.newEmployee");
                }
                else {
                    args.dialog.header = this.$t("calendarTypes.editEmployee", {
                        name: args.rowData["employeeFullName"]
                    });
                }
            }
        },
        roomsGridActionBegin(args) {
            if (args.requestType === "save") {
                args.data["roomName"] = args.form.querySelector("#roomId").value;
            }
        },
        roomsGridActionComplete(args) {
            if (args.requestType === "beginEdit" || args.requestType === "add") {
                // Add Validation Rules
                const calendarTypeRooms = this.calendarType.rooms;
                args.form.ej2_instances[0].addRules("roomId", {
                    exists: [
                        function (args) {
                            const roomIdOld = args.element.form.querySelector("#roomIdOld").value;
                            if (args.value == roomIdOld)
                                return true;
                            return !calendarTypeRooms.some(room => room.roomId == args.value);
                        },
                        this.$t("calendarTypes.roomExists")
                    ]
                });
                args.dialog.width = 380;
                if (args.requestType === "add") {
                    args.dialog.header = this.$t("calendarTypes.newRoom");
                }
                else {
                    args.dialog.header = this.$t("calendarTypes.editRoom", {
                        name: args.rowData["roomName"]
                    });
                }
            }
        }
    },
    async mounted() {
        this.showSpinner();
        try {
            this.offices = await this.$store.dispatch("office/getAll");
            this.calendarType.employees = [];
            this.calendarType.rooms = [];
            if (!this.hasMultipleOffices)
                this.calendarType.officeId = this.getSingleOfficeId;
        }
        catch (errors) {
            this.$toast.showDangerToast(this.$t("shared.toastFailureTitle"), this.$t("shared.toastFailureContent", {
                error: errors[0].message
            }));
            await this.$router.push("/administration/calendar-types");
        }
        finally {
            this.hideSpinner();
        }
    }
});
